import * as yup from 'yup';

const familyName = {
  base: yup.string().typeError('errorMessages.string')
};
familyName.required = familyName.base.required('errorMessages.required');
familyName.optional = familyName.base;

export default familyName;
